export default "__VITE_ASSET__apweeubG__"